<div class="spinner_load">
  <mat-progress-spinner
      class="example-margin"
      [color]="color"
      [mode]="mode"
      [diameter]="size"
      [value]="value">
  </mat-progress-spinner>
</div>